import React, { useEffect } from "react";
import "./Order_list_table.css";
// import { Form } from "react-router-dom";
// import { Table } from "react-bootstrap";
import { Form, Table } from "react-bootstrap";
import { variant_type, getVariantImage } from "../../../../utils/common";
import { Link } from "react-router-dom";

function Replace_Order_list_table({
  id,
  val,
  selectedItems,
  setSelectedItems,
  setError,
  error,
  product,
  selectedVariant,
  setActiveSize,
  activeSize,
  setSelectedVariant,
  activeMetal,
  setActiveMetal,
}) {
  const handleCheckboxChange = (val) => {
    setSelectedItems((prev) => {
      const exists = prev.some((item) => item.id === val.id);

      if (exists) {
        return prev.filter((item) => item.id !== val.id);
      } else {
        return [...prev, val];
      }
    });
  };

  const variantError = error?.variant;

  // useEffect(() => {
  //   if (activeMetal?.Double_Variants?.length > 0) {
  //     setSelectedVariant(activeMetal?.Double_Variants?.[0]);
  //     setActiveSize(activeMetal?.Double_Variants?.[0]);
  //   }
  // }, [activeMetal]);

  useEffect(() => {
    if (!activeMetal) return;

    if (Number(product?.variant_type_id) === Number(variant_type.Single)) {
      setSelectedVariant(activeMetal);
      setActiveSize(null);
      return;
    }

    if (Number(product?.variant_type_id) === Number(variant_type.Double)) {
      const firstSize = activeMetal?.Double_Variants?.[0] || null;

      setActiveSize(firstSize);
      setSelectedVariant(firstSize);
    }
  }, [activeMetal, product?.variant_type_id]);
  return (
    <>
      <div className="order_list_table Order_details_table Cart_Products_card ">
        <div className="inner_box_div d-none d-lg-block">
          <div className="row align-items-center ">
            <div className="col-sm-8 ">
              <div className="row">
                <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-3 col-3">
                  <div className="img_holder">
                    <img
                      className="Product_img"
                      src={getVariantImage(val)}
                      alt={"Product_img"}
                    />
                  </div>
                </div>
                <div className="col-xxl-10 col-xl-9 col-lg-9 col-md-9 col-9">
                  <div className="info_text_holder">
                    <div>
                      <h4>{val?.Product?.name}</h4>

                      <h6>
                        {val?.Product?.variant_type_id ===
                          variant_type.Single && (
                          <>
                            <b>
                              <strong className="text_bold_holder">
                                {val?.Product?.variant_name || "Color"}:
                              </strong>{" "}
                            </b>
                            {val?.Product_Variant?.Metal?.name}
                          </>
                        )}

                        {val?.Product?.variant_type_id ===
                          variant_type.Double && (
                          <>
                            <strong>{val?.Product?.variant_name}:</strong>{" "}
                            {val?.Double_Variant?.Product_Variant?.Metal?.name},{" "}
                            <b>
                              <strong className="text_bold_holder">
                                {" "}
                                Size:
                              </strong>{" "}
                            </b>
                            {val?.Double_Variant?.Size?.name}{" "}
                          </>
                        )}

                        {val?.Product?.variant_type_id ===
                          variant_type.Triple && (
                          <>
                            <b>
                              <strong className="text_bold_holder">
                                {" "}
                                Size:
                              </strong>{" "}
                            </b>
                            {
                              val?.Triple_Variant?.Double_Variant
                                ?.Product_Variant?.Metal?.name
                            }
                            {/* , <strong>Size:</strong>{" "} */}
                            {val?.Triple_Variant?.Double_Variant?.Size?.name}
                            {/* , <strong>Diamond:</strong>{" "} */}
                            {val?.Triple_Variant?.Diamond?.name}
                          </>
                        )}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-4 ">
              <div className="">
                <div className="new_price_holder">
                  <div className="price_inner_text">
                    <p className="right_label">Price </p>
                    <p className="colon_text">:</p>₹{val?.selling_price}
                  </div>

                  <div className="price_inner_text">
                    <p className="right_label">Order Qty </p>
                    <p className="colon_text">:</p>
                    {val?.quantity}
                  </div>

                  <div className="price_inner_text">
                    <p className="right_label">Total Price </p>
                    <p className="colon_text">:</p>₹{" "}
                    {val?.quantity * val?.selling_price}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="d-block d-lg-none mobile_view_holder">
          <div className="mobile_product_card replace_div" key={val?.id}>
            <Link
              to={`/product-details/${val?.Product?.id}`}
              className="text-decoration-none text-dark"
            >
              <div className="order_holder">
                <div className="order_holder_left">
                  <div className="img_holder">
                    <img
                      className="Product_img"
                      src={getVariantImage(val)}
                      alt={val?.Product?.name}
                    />
                  </div>
                </div>

                <div className="order_holder_right">
                  <div className="descn_holder">
                    <div className="left_div">
                      <h6 className="product_name mb-2">
                        {val?.Product?.name}
                      </h6>

                      <div className="new">
                        {val?.Product?.variant_type_id ===
                          variant_type.Single && (
                          <>
                            {/* <>Variant :</>{" "} */}
                            <>
                              <strong>{val?.Product?.variant_name} : </strong>
                            </>{" "}
                            {val?.Product_Variant?.Metal?.name}
                          </>
                        )}

                        {val?.Product?.variant_type_id ===
                          variant_type.Double && (
                          <>
                            {/* <>Variant :</>{" "} */}
                            <>
                              <strong>{val?.Product?.variant_name} :</strong>
                            </>{" "}
                            {val?.Double_Variant?.Product_Variant?.Metal?.name}
                            <br></br>
                            <strong>Size :</strong>{" "}
                            {val?.Double_Variant?.Size?.name}{" "}
                          </>
                        )}

                        {val?.Product?.variant_type_id ===
                          variant_type.Triple && (
                          <>
                            {/* <>Variant :</>{" "} */}
                            <>
                              <strong>{val?.Product?.variant_name} :</strong>
                            </>{" "}
                            {
                              val?.Triple_Variant?.Double_Variant
                                ?.Product_Variant?.Metal?.name
                            }
                            <br></br>
                            <strong>Size:</strong>{" "}
                            {val?.Triple_Variant?.Double_Variant?.Size?.name},{" "}
                            <strong>Diamond:</strong>{" "}
                            {val?.Triple_Variant?.Diamond?.name}
                          </>
                        )}
                      </div>

                      {val?.Product_Variant?.name && (
                        <p className="mb-1">
                          <strong>Polish :</strong> {val?.Product_Variant?.name}
                        </p>
                      )}

                      {val?.Double_Variant?.name && (
                        <p className="mb-1">
                          <strong>Colour :</strong> {val?.Double_Variant?.name}
                        </p>
                      )}

                      {val?.Triple_Variant?.name && (
                        <p className="mb-1">
                          <strong>Size :</strong> {val?.Triple_Variant?.name}
                        </p>
                      )}
                    </div>

                    <div className="price_details">
                      <p className="mb-1">
                        <strong>₹{val?.selling_price}</strong> X {val?.quantity}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>

        <div
          className="Product_info"
          style={{
            border: variantError ? "1px solid red" : "1px solid transparent",
            borderRadius: "6px",
            padding: "10px",
          }}
        >
          <div className="quantity_holder">
            <p className="type_text">
              {" "}
              {product?.variant_name || "Color"}:{" "}
              {selectedVariant?.Product_Variant?.Metal?.name ||
                selectedVariant?.Size?.name ||
                "Color"}
            </p>
            <div className="d-flex flex-wrap">
              {product?.Product_Variants?.map((option) => (
                <div className="me-1" key={option.id}>
                  <div
                    className={`color_img_holder ${
                      // Number(option?.general_stock) <= 0
                      //   ? "color_img_holder_not_available"
                      activeMetal?.id === option.id ? "active" : ""
                    }`}
                    // className={`quantity_box_holder prodnotavailable ${
                    //   activeMetal?.id === option.id ? "active" : ""
                    // }`}
                    // onClick={() => {
                    //   setActiveMetal(option);
                    //   if (product?.variant_type_id === variant_type.Single) {
                    //     setSelectedVariant(option);
                    //   }
                    // }}
                    onClick={() => {
                      setActiveMetal(option);

                      setError((prevError) => ({
                        ...prevError,
                        variant: "",
                      }));

                      if (
                        Number(product?.variant_type_id) ===
                        Number(variant_type.Single)
                      ) {
                        setSelectedVariant(option);
                      }
                    }}
                  >
                    {/* <div className="info_holder">
                    <h5>{option?.Metal?.name}</h5>
                  </div> */}

                    <img
                      className="color_img"
                      alt="color"
                      src={
                        process.env.REACT_APP_IMG_URL +
                          option?.Product_Images[0]?.image ||
                        "/assets/images/product_color_varient_img/img_1.webp"
                      }
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {product?.Product_Variants?.find((v) => v.id === activeMetal?.id)
            ?.Double_Variants?.length > 0 && (
            <div className="quantity_holder">
              <p className="type_text">Size</p>
              <div className="d-flex flex-wrap">
                {product.Product_Variants.find(
                  (v) => v.id === activeMetal?.id,
                ).Double_Variants.map((item) => (
                  <div className="sizebox mb-3 me-2" key={item.id}>
                    <div
                      // className={`quantity_box_holder  prodnotavailable ${
                      //   activeSize?.id === item.id ? "active" : ""
                      // }`}

                      className={`quantity_box_holder 
                         ${item.stock <= 0 ? "prodnotavailable" : ""} 
                         ${activeSize?.id === item.id ? "active" : ""}
                        `}
                      // onClick={() => {
                      //   setActiveSize(item);
                      //   // setActiveTriple(null);
                      //   if (product?.variant_type_id === variant_type.Double) {
                      //     setSelectedVariant(item);
                      //   }
                      // }}
                      onClick={() => {
                        if (item.stock <= 0) return;

                        setActiveSize(item);

                        setError((prevError) => ({
                          ...prevError,
                          variant: "",
                        }));

                        if (
                          Number(product?.variant_type_id) ===
                          Number(variant_type.Double)
                        ) {
                          setSelectedVariant(item);
                        }
                      }}
                    >
                      <div className="info_holder">
                        <h5>{item?.Size?.name}</h5>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {variantError && (
            <p
              style={{
                color: "red",
                fontSize: "14px",
                marginTop: "8px",
                marginBottom: "0",
              }}
            >
              {variantError}
            </p>
          )}

          {/* {product?.variant_type_id === 1
            ? selectedVariant?.general_stock
            : selectedVariant?.stock > 0
            ? selectedVariant?.stock
            : "This Variant Out Of Stock"} */}
        </div>
      </div>
    </>
  );
}

export default Replace_Order_list_table;
